import React from 'react';

const NotFound = ({ language }) => {
    const translations = {
        title: {
            zh: '页面未找到',
            en: 'Page Not Found'
        },
        message: {
            zh: '您请求的页面不存在或已被移除。',
            en: 'The page you requested does not exist or has been removed.'
        },
        back: {
            zh: '返回首页',
            en: 'Back to Home'
        }
    };

    return (
        <div className="text-center py-5">
            <h1 className="display-1">404</h1>
            <h2>{translations.title[language]}</h2>
            <p className="lead">{translations.message[language]}</p>
            <a href="/" className="btn btn-primary mt-3">
                <i className="bi bi-house-door me-2"></i>
                {translations.back[language]}
            </a>
        </div>
    );
};

export default NotFound; 